module.exports = "/images/ny-blck-13.jpg";